import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';

// const inOutPaneAnimation = trigger('inOutPaneAnimation', [
//   enterInOutTransition,
//   leaveInOutTransition,
// ]);

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class ModalComponent {
  @Input() modalContent!: TemplateRef<object>;
  @Input() size: string | undefined = 'dialog-lg';
  @Input() title: string | undefined = 'modal title';
  @Input() message: string | undefined = '';
  @Input() submitLabel: string | undefined = 'تأكيد';
  @Input() cancelLabel: string | undefined = 'إلغاء الامر';
  @Input() showCancelBtn: boolean | undefined = true;
  @Input() showCloseBtn: boolean | undefined = true;
  @Input() showSubmitBtn: boolean | undefined = true;
  @Input() showHeader: boolean | undefined = true;
  @Input() alignCenter: boolean | undefined = false;
  @Input() isOpen: boolean | undefined = false;

  @Output() closeEvent = new EventEmitter();
  @Output() submitEvent = new EventEmitter();

  header = document.getElementById('ng_header');

  constructor(private elementRef: ElementRef) {}
  close() {
    this.isOpen = !this.isOpen;
    this.elementRef.nativeElement.remove();
    this.closeEvent.emit();
    this.header.classList.remove('remove-z-index');
  }

  submit() {
    this.isOpen = !this.isOpen;
    this.elementRef.nativeElement.remove();
    this.submitEvent.emit();
    this.header.classList.remove('remove-z-index');
  }
}
